unit MedicineItemListType;
{

/* Initial. */

}
interface

uses
  MedicineItemType;

type
  TMedicineItemListType = array of TMedicineItemType;

implementation

end.
